import React, {Fragment, type ReactNode} from 'react';

import {useAccountSettingsState} from 'app/settings/api';

type Props = {
  sharingEnabledElement: ReactNode | null;
  sharingDisabledElement: ReactNode | null;
};
export const DataSharingEnabledGate = ({
  sharingEnabledElement,
  sharingDisabledElement,
}: Props) => {
  const {require_ai_data_sharing_at} = useAccountSettingsState().data!;

  if (require_ai_data_sharing_at) {
    return <Fragment>{sharingEnabledElement}</Fragment>;
  } else {
    return <Fragment>{sharingDisabledElement}</Fragment>;
  }
};
